<template>
  <div class="has-[>*]:min-h-[1.4375rem]">
    <PaymentAdvertisement
      v-if="selectedOffer"
      :base-price="price"
      icon-classes="w-[40px] flex-shrink-0 mr-8 self-center"
      :payment-methods="selectedOffer.paymentMethods"
      spot="product"
      @open="trackOpen"
    />
  </div>
</template>

<script lang="ts" setup>
import type { Price } from '@backmarket/http-api'
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { PaymentAdvertisement } from '@backmarket/nuxt-layer-payment/advertising'
import type { usePaymentAdvertisement } from '@backmarket/nuxt-layer-payment/advertising/composables/usePaymentAdvertisement'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

withDefaults(
  defineProps<{
    selectedOffer?: GetPickersResponse['selectedOffer'] | null
    price: Price
  }>(),
  {
    selectedOffer: null,
  },
)

const { trackClick } = useTracking()

function trackOpen(advertisement: ReturnType<typeof usePaymentAdvertisement>) {
  trackClick({
    zone: 'installment plans',
    name: advertisement.value?.isAdvertised
      ? advertisement.value?.method.networks.join(',')
      : '',
  })
}
</script>
